import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=448a5f52"
import script from "./MainCard.vue?vue&type=script&lang=ts"
export * from "./MainCard.vue?vue&type=script&lang=ts"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=448a5f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports